import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { GeneralCalcSalaryInputsComponent } from 'src/app/pages/hr/general-calc-salary-inputs/general-calc-salary-inputs.component';
import { SalaryService } from 'src/app/shared/services/hr/salary.service';

@Component({
  selector: 'app-show-employee-work-durations',
  templateUrl: './show-employee-work-durations.component.html',
  styleUrls: ['./show-employee-work-durations.component.scss']
})
export class ShowEmployeeWorkDurationsComponent implements OnInit {

  @ViewChild('dataGridVar', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('salaryInputs', { static: false }) salaryInputsComponent: GeneralCalcSalaryInputsComponent;

  LOCALIZATION_LOCAL_STORAGE_KEY = 'Language';
  currentLang: any;

  showConfirmPopup = false;
  showResultPopup = false;
  selectedItems: { employeeId: number; date: string }[] = [];
  deleteResult: any = null;

  filterFormData: any = {};
  gridDataSource: any[] = [];

  constructor(private salaryService: SalaryService) {
    this.currentLang = localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY);
  }

  ngOnInit(): void {}

  onFormDataChanged(formData: any): void {
    this.filterFormData = formData;
  }

  applyFilter(): void {
    const formData = this.salaryInputsComponent?.getFormData() || this.filterFormData;
    const requestData = this.prepareRequestData(formData);
    this.loadData(requestData);
  }

  resetFilter(): void {
    this.salaryInputsComponent?.resetForm();
    this.filterFormData = {};
    this.gridDataSource = [];
  }

  prepareRequestData(formData: any): any {
    const formatDate = (date: any): string | null => {
      if (!date) return null;
      if (date instanceof Date) return date.toISOString();
      if (typeof date === 'string') {
        const d = new Date(date);
        if (!isNaN(d.getTime())) return d.toISOString();
      }
      return date;
    };

    return {
      FromDate: formatDate(formData.fromDate),
      ToDate: formatDate(formData.toDate),
      EmployeeIds: formData.employeeIds?.length ? formData.employeeIds : [],
      DepartmentIds: formData.departmentIds?.length ? formData.departmentIds : [],
      ManagementIds: formData.managementIds?.length ? formData.managementIds : [],
      BranchIds: formData.branchIds?.length ? formData.branchIds : [],
      WorkSystemIds: formData.workSystemIds?.length ? formData.workSystemIds : [],
      JobTitleIds: formData.jobTitleIds?.length ? formData.jobTitleIds : []
    };
  }

  loadData(requestData: any): void {
    this.salaryService.getEmployeeWorkDurations(requestData).subscribe({
      next: (response: any) => {
        const raw = Array.isArray(response) ? response : (response?.data || []);
        this.gridDataSource = this.flattenDurations(raw);

        this.dataGrid?.instance.refresh();
      },
      error: (err) => console.error('API error:', err)
    });
  }

  private flattenDurations(data: any[]): any[] {
    const flattened: any[] = [];

    data.forEach((dayObj, idx) => {
      const systems = dayObj?.durationWorkSystems || [];

      if (Array.isArray(systems) && systems.length) {
        systems.forEach((sys: any, sysIndex: number) => {
          flattened.push({
            id: `${dayObj.employeeId}_${dayObj.dateTimeRegister}_${sys.durationWorkSystemId}_${sysIndex}`,
            employeeId: dayObj.employeeId,
            employeeName: dayObj.employeeName,
            day: dayObj.day,
            dateTimeRegister: dayObj.dateTimeRegister,
            vacation: dayObj.vacation,
            durationWorkSystemId: sys.durationWorkSystemId,
            nameAr: sys.nameAr,
            numberOfHours: this.calculateWorkingHours(sys.attendanceFromHour, sys.leaveToHour),
            attendanceFromHour: sys.attendanceFromHour,
            leaveToHour: sys.leaveToHour
          });
        });
      } else {
        flattened.push({
          id: `${dayObj.employeeId}_${dayObj.dateTimeRegister}_${idx}`,
          employeeId: dayObj.employeeId,
          employeeName: dayObj.employeeName,
          day: dayObj.day,
          dateTimeRegister: dayObj.dateTimeRegister,
          vacation: dayObj.vacation,
          durationWorkSystemId: null,
          nameAr: null,
          numberOfHours: null,
          attendanceFromHour: null,
          leaveToHour: null
        });
      }
    });

    return flattened;
  }

  private calculateWorkingHours(from: string, to: string): number {
    if (!from || !to) return 0;

    const [fromH, fromM] = from.split(':').map(Number);
    const [toH, toM] = to.split(':').map(Number);

    const fromDate = new Date();
    fromDate.setHours(fromH, fromM, 0, 0);

    const toDate = new Date();
    toDate.setHours(toH, toM, 0, 0);

    if (toDate <= fromDate) {
      toDate.setDate(toDate.getDate() + 1);
    }

    const diffMs = toDate.getTime() - fromDate.getTime();
    const hours = diffMs / (1000 * 60 * 60);

    return +hours.toFixed(3);
  }

  // ✅ دلوقتي بيبني List of {employeeId, date} من الصفوف المحددة
  // بيشيل التكرار لو اخترت أكتر من فترة عمل لنفس الموظف في نفس اليوم
  deleteSelected(): void {
    const selectedRows = this.dataGrid.instance.getSelectedRowsData();

    if (!selectedRows.length) {
      alert('اختر صف واحد على الأقل');
      return;
    }

    const itemsMap = new Map<string, { employeeId: number; date: string }>();

    selectedRows.forEach((r: any) => {
      const dateOnly = (r.dateTimeRegister || '').toString().split('T')[0];
      const key = `${r.employeeId}_${dateOnly}`;

      if (!itemsMap.has(key)) {
        itemsMap.set(key, {
          employeeId: r.employeeId,
          date: dateOnly
        });
      }
    });

    this.selectedItems = Array.from(itemsMap.values());
    this.showConfirmPopup = true;
  }

  confirmDelete(): void {
    this.showConfirmPopup = false;

    const request = {
      Items: this.selectedItems.map(i => ({
        EmployeeId: i.employeeId,
        Date: i.date
      }))
    };

    this.salaryService.deleteEmployeeWorkSchedule(request).subscribe({
      next: (response: any) => {
        const data = response?.data;

        this.deleteResult = {
          deletedEmployees: data?.deletedEmployees || [],
          failedEmployees: data?.failedEmployees || []
        };

        this.showResultPopup = true;

        if (this.deleteResult.deletedEmployees.length) {
          this.applyFilter();
        }
      },
      error: (err) => console.error('Delete error:', err)
    });
  }
}